module.exports = __webpack_public_path__ + "img/egypt.7ec1ef88.png";